<template>
  <div v-if="isLoading" class="loading-overlay bg-background/80 backdrop-blur-sm">
    <div class="loading-container">
      <div class="animate-spin rounded-full h-16 w-16 border-b-3 border-indigo-500"></div>
      <div class="loading-text">
        <span class="text-primary-500 dark:text-white" v-for="(char, index) in 'Đang tải...'.split('')" :key="index"
              :style="{ animationDelay: `${index * 0.08}s` }">{{ char }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useLoading} from '@/composables/useLoading.ts';

const {isLoading} = useLoading();
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  transition: opacity 0.3s ease;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.loading-text {
  color: white;
  font-size: 1.1rem;
  font-weight: 500;
  display: flex;
}

.loading-text span {
  display: inline-block;
  animation: waveText 1.2s infinite ease-in-out alternate;
  margin-right: 0.3rem;
}

@keyframes waveText {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(8px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
